module.exports = __webpack_public_path__ + "img/back.d12354d5.svg";